import { useTranslation } from "react-i18next";

export const WithdrawlError = () => {
  const { t } = useTranslation();

  return (
    <main>
      <section className="container__standart">
        <h2
          style={{
            padding: "18.75rem 0rem 12.5rem 0rem",
            textAlign: "center",
            lineHeight: "5rem",
          }}
        >
          {t("withdrawlError.title1")}
          <br /> {t("withdrawlError.title2")}
        </h2>
      </section>
    </main>
  );
};
